import { createReducer, on } from '@ngrx/store';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';
import {
  AcknowledgePrivateTransitCargoConditionsActions,
  GetCargoReviewActions,
  RecommendCargoDecisionActions,
  GetPrivateTransitCargoRequestActions,
  ListPrivateTransitCargoRequestsActions,
  PrivateTransitCargoState,
  ResubmitPrivateTransitCargoForApprovalActions,
  SavePrivateTransitCargoRequestActions,
  SubmitPrivateTransitCargoRequestActions,
  UpdatePrivateTransitCargoRequestActions,
  WithdrawPrivateTransitCargoRequestActions,
} from './private-transit-cargo.actions';

const initialRequestState = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialPrivateTransitCargoState: PrivateTransitCargoState = {
  reviewDetails: initialRequestState,
  recommendation: initialRequestState,
  list: initialRequestState,
  details: initialRequestState,
  saveDraft: initialRequestState,
  updateDraft: initialRequestState,
  submitRequest: initialRequestState,
  resubmitRequest: initialRequestState,
  withdrawRequest: initialRequestState,
  acknowledgeConditions: initialRequestState,
};

export const privateTransitCargoReducer = createReducer(
  initialPrivateTransitCargoState,

  on(GetCargoReviewActions.request, (state) => handleRequest(state, 'reviewDetails')),
  on(GetCargoReviewActions.success, (state, { response }) => handleSuccess(state, 'reviewDetails', response)),
  on(GetCargoReviewActions.failure, (state, { error }) => handleFailure(state, 'reviewDetails', error)),
  on(GetCargoReviewActions.clearState, (state) => handleClear(state, 'reviewDetails')),

  on(RecommendCargoDecisionActions.request, (state) => handleRequest(state, 'recommendation')),
  on(RecommendCargoDecisionActions.success, (state, { response }) => handleSuccess(state, 'recommendation', response)),
  on(RecommendCargoDecisionActions.failure, (state, { error }) => handleFailure(state, 'recommendation', error)),
  on(RecommendCargoDecisionActions.clearState, (state) => handleClear(state, 'recommendation')),

  // List
  on(ListPrivateTransitCargoRequestsActions.request, (state) => handleRequest(state, 'list')),
  on(ListPrivateTransitCargoRequestsActions.success, (state, { response }) =>
    handleSuccess(state, 'list', response),
  ),
  on(ListPrivateTransitCargoRequestsActions.failure, (state, { error }) =>
    handleFailure(state, 'list', error),
  ),
  on(ListPrivateTransitCargoRequestsActions.clearState, (state) => handleClear(state, 'list')),

  // Details
  on(GetPrivateTransitCargoRequestActions.request, (state) => handleRequest(state, 'details')),
  on(GetPrivateTransitCargoRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'details', response),
  ),
  on(GetPrivateTransitCargoRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'details', error),
  ),
  on(GetPrivateTransitCargoRequestActions.clearState, (state) => handleClear(state, 'details')),

  // Save Draft
  on(SavePrivateTransitCargoRequestActions.request, (state) => handleRequest(state, 'saveDraft')),
  on(SavePrivateTransitCargoRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'saveDraft', response),
  ),
  on(SavePrivateTransitCargoRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'saveDraft', error),
  ),
  on(SavePrivateTransitCargoRequestActions.clearState, (state) => handleClear(state, 'saveDraft')),

  // Update Draft
  on(UpdatePrivateTransitCargoRequestActions.request, (state) => handleRequest(state, 'updateDraft')),
  on(UpdatePrivateTransitCargoRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'updateDraft', response),
  ),
  on(UpdatePrivateTransitCargoRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'updateDraft', error),
  ),
  on(UpdatePrivateTransitCargoRequestActions.clearState, (state) => handleClear(state, 'updateDraft')),

  // Submit Request
  on(SubmitPrivateTransitCargoRequestActions.request, (state) => handleRequest(state, 'submitRequest')),
  on(SubmitPrivateTransitCargoRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'submitRequest', response),
  ),
  on(SubmitPrivateTransitCargoRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'submitRequest', error),
  ),
  on(SubmitPrivateTransitCargoRequestActions.clearState, (state) => handleClear(state, 'submitRequest')),

  // Resubmit Request
  on(ResubmitPrivateTransitCargoForApprovalActions.request, (state) => handleRequest(state, 'resubmitRequest')),
  on(ResubmitPrivateTransitCargoForApprovalActions.success, (state, { response }) =>
    handleSuccess(state, 'resubmitRequest', response),
  ),
  on(ResubmitPrivateTransitCargoForApprovalActions.failure, (state, { error }) =>
    handleFailure(state, 'resubmitRequest', error),
  ),
  on(ResubmitPrivateTransitCargoForApprovalActions.clearState, (state) => handleClear(state, 'resubmitRequest')),

  // Withdraw Request
  on(WithdrawPrivateTransitCargoRequestActions.request, (state) => handleRequest(state, 'withdrawRequest')),
  on(WithdrawPrivateTransitCargoRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'withdrawRequest', response),
  ),
  on(WithdrawPrivateTransitCargoRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'withdrawRequest', error),
  ),
  on(WithdrawPrivateTransitCargoRequestActions.clearState, (state) => handleClear(state, 'withdrawRequest')),

  // Acknowledge Conditions
  on(AcknowledgePrivateTransitCargoConditionsActions.request, (state) => handleRequest(state, 'acknowledgeConditions')),
  on(AcknowledgePrivateTransitCargoConditionsActions.success, (state, { response }) =>
    handleSuccess(state, 'acknowledgeConditions', response),
  ),
  on(AcknowledgePrivateTransitCargoConditionsActions.failure, (state, { error }) =>
    handleFailure(state, 'acknowledgeConditions', error),
  ),
  on(AcknowledgePrivateTransitCargoConditionsActions.clearState, (state) => handleClear(state, 'acknowledgeConditions')),
);

